import { render, staticRenderFns } from "./RoleCreateView.vue?vue&type=template&id=56530847"
import script from "./RoleCreateView.vue?vue&type=script&lang=js"
export * from "./RoleCreateView.vue?vue&type=script&lang=js"
import style0 from "./RoleCreateView.vue?vue&type=style&index=0&id=56530847&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports